<template>
    <div class="dashboard__calendar">
        <div class="card card--with-heading">
            <h4>
                Calendario de
                {{ userRole === "buyer" ? "recepción" : "entregas" }}
            </h4>
            <table v-if="canGetData" class="n-table">
                <div v-if="!showNoDataMessage">
                    <thead>
                        <tr>
                            <th>Semana</th>
                            <th>Ofertado</th>
                            <th>
                                {{
                                    userRole === "buyer"
                                        ? "Recibido / A recibir"
                                        : "Entregado / A entregar"
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="calendar-arrows">
                                <button class="btn" @click="setMonth(-1)">
                                    <vs-icon icon="keyboard_arrow_up" />
                                </button>
                            </td>
                        </tr>
                        <tr
                            v-for="(weekStat, ix) in calendarWeeks"
                            :key="ix + weekStat.week + userRole"
                        >
                            <td data-label="Semana">{{ weekStat.week }}</td>
                            <td data-label="Ofertado">
                                <span class="we-tooltip">
                                    <div
                                        class="we-tooltip__host"
                                        :class="{
                                            disabled: !weekStat.results.offered,
                                        }"
                                        aria-describedby="tooltip-offered"
                                        aria-expanded="false"
                                        aria-label="Ofertado"
                                    >
                                        {{
                                            weekStat.results.offered
                                                ? weekStat.results.offered
                                                : "-"
                                        }}
                                    </div>
                                    <div
                                        class="we-tooltip__overlay"
                                        id="tooltip-toDeliver"
                                        role="tooltip"
                                    >
                                        <span
                                            class="we-tooltip__pointer we-tooltip__pointer--bottom-left"
                                        ></span>

                                        <div class="we-tooltip__mask">
                                            <div class="we-tooltip__content">
                                                <div class="we-tooltip-title">
                                                    Cantidad de animales:
                                                    {{
                                                        weekStat.results
                                                            .offeredQuantity
                                                    }}
                                                </div>
                                                <div class="offers">
                                                    <div
                                                        :key="offer.offerId"
                                                        v-for="offer in weekStat
                                                            .results
                                                            .offeredOffers"
                                                    >
                                                        <span class="offer-id"
                                                            >Oferta #{{
                                                                offer.offerId
                                                            }}</span
                                                        >
                                                        <span
                                                            class="offer-price"
                                                            >Precio sin
                                                            IVA:</span
                                                        >
                                                        <span
                                                            class="offer-value"
                                                            >{{
                                                                offer.price
                                                            }}</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </td>
                            <td data-label="A entregar">
                                <span class="we-tooltip">
                                    <div
                                        class="we-tooltip__host"
                                        :class="{
                                            disabled:
                                                !weekStat.results.toDeliver &&
                                                !weekStat.results.negotiations,
                                        }"
                                        aria-describedby="tooltip-toDeliver"
                                        aria-expanded="false"
                                        aria-label="A entregar"
                                    >
                                        {{
                                            weekStat.results.toDeliver +
                                            weekStat.results.negotiated
                                                ? weekStat.results.toDeliver +
                                                  weekStat.results.negotiated
                                                : "-"
                                        }}
                                    </div>
                                    <div
                                        class="we-tooltip__overlay"
                                        id="tooltip-toDeliver"
                                        role="tooltip"
                                    >
                                        <span
                                            class="we-tooltip__pointer we-tooltip__pointer--bottom-left"
                                        ></span>

                                        <div class="we-tooltip__mask">
                                            <div class="we-tooltip__content">
                                                <div class="we-tooltip-title">
                                                    Cantidad de animales:
                                                    {{
                                                        weekStat.results
                                                            .quantityToDeliver +
                                                        weekStat.results
                                                            .negotiated
                                                    }}
                                                </div>
                                                <div class="offers">
                                                    <div
                                                        v-for="(
                                                            offer, index
                                                        ) in weekStat.results
                                                            .offersToDeliver"
                                                        :key="index"
                                                    >
                                                        <span class="offer-id"
                                                            >Oferta #{{
                                                                offer.offerId
                                                            }}</span
                                                        >
                                                        <span
                                                            class="offer-price"
                                                            >Precio sin
                                                            IVA:</span
                                                        >
                                                        <span
                                                            class="offer-value"
                                                        >
                                                            {{
                                                                offer.price
                                                            }}</span
                                                        >
                                                    </div>
                                                </div>
                                                <!-- Son las neg. donde participó como contraparte. Debería cambiarse o distinguirse las clases de las ofertas parciales -->
                                                <div
                                                    class="negotiations offers"
                                                >
                                                    <div
                                                        v-for="(
                                                            neg, index
                                                        ) in weekStat.results
                                                            .negotiations"
                                                        :key="index"
                                                    >
                                                        <span class="offer-id"
                                                            >Oferta #{{
                                                                neg.offerId
                                                            }}<br />

                                                            <!-- 
                                                                Si se quiere agregar algo de la negociación se puede poner algo como:  
                                                                Neg. #{{neg.id }}
                                                            -->
                                                        </span>

                                                        <span
                                                            class="offer-price"
                                                            >Precio sin
                                                            IVA:</span
                                                        >
                                                        <span
                                                            class="offer-value"
                                                        >
                                                            {{
                                                                neg.price
                                                            }}</span
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td class="calendar-arrows">
                                <button class="btn" @click="setMonth(1)">
                                    <vs-icon icon="keyboard_arrow_down" />
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </div>
                <div v-if="this.showNoDataMessage">
                    <div class="alert info">
                        <vs-icon icon="info" />
                        No existe suficiente información para mostrar el
                        calendario de
                        {{ userRole === "buyer" ? "recepción" : "entregas" }}
                    </div>
                </div>
            </table>
            <div v-else>Seleccione una empresa para ver los datos</div>
        </div>
    </div>
</template>

<script>
import DashboardFilters from "./DashboardFilters.vue";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";
import { mapState } from "vuex";

const userCalendar = gql`
    query userCalendar(
        $currentUserToken: String!
        $dateFrom: String
        $dateTo: String
        $userRoleType: String
        $scopedOrganizationId: String
    ) {
        userCalendar(
            currentUserToken: $currentUserToken
            dateFrom: $dateFrom
            dateTo: $dateTo
            userRoleType: $userRoleType
            scopedOrganizationId: $scopedOrganizationId
        ) {
            week
            results {
                avgPrice
                offered
                offeredAvgPrice
                offeredOffers {
                    offerId
                    price
                }
                offeredQuantity
                offers {
                    offerId
                    price
                }
                offersToDeliver {
                    offerId
                    price
                }
                quantity
                quantityToDeliver
                toDeliver
                toDeliverAvgPrice
                negotiated
                negotiations {
                    id
                    price
                    quantity
                    offerId
                }
            }
        }
    }
`;

export default {
    name: "calendar-dashboard",
    components: {
        DashboardFilters,
    },
    computed: {
        ...mapState({
            currentUser: (state) => state.User.currentUser,
        }),
        canGetData() {
            return (this.isAdmin && this.scopedOrganizationId) || !this.isAdmin;
        },
    },
    beforeMount() {
        if (this.currentUser.id) {
            this.date = this.parseDate(this.currentUser.currentTime);
            if (this.canGetData) {
                this.getCalendarData();
            }
        } else {
            this.date = new Date();
        }
    },
    props: {
        dashboardTab: {
            type: String,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        organizations: {
            type: Array,
            required: false,
            default: [],
        },
        userRole: {
            type: String,
            required: false,
            default: "buyer",
        },
        scopedOrganizationId: {
            type: Number,
            required: false,
        },
    },
    watch: {
        "currentUser.currentTime"() {
            this.date = this.parseDate(this.currentUser.currentTime);
            if (this.canGetData) {
                this.getCalendarData();
            }
        },
        scopedOrganizationId() {
            if (this.isAdmin) {
                this.getCalendarData();
            }
        },
    },
    data() {
        return {
            calendarWeeks: [],
            date: "",
            showNoDataMessage: false,
        };
    },
    methods: {
        dateFrom() {
            var dt = JSON.parse(JSON.stringify(this.date));
            dt = this.parseDate(dt);
            dt.setMonth(dt.getMonth() - 1);
            return `${dt.getFullYear()}-${dt.getMonth() + 1}`;
        },
        dateTo() {
            var dt = JSON.parse(JSON.stringify(this.date));
            dt = this.parseDate(dt);
            dt.setMonth(dt.getMonth() + 1);
            return `${dt.getFullYear()}-${dt.getMonth() + 1}`;
        },
        setMonth(n) {
            this.date.setMonth(this.date.getMonth() + n);
            this.getCalendarData();
        },
        parseDate(date) {
            var splitted = date.replace(/T/g, " ").split(" ")[0].split("-");
            var dt = new Date(
                parseInt(splitted[0]),
                parseInt(splitted[1]) - 1,
                parseInt(splitted[2])
            );
            return dt;
        },
        getCalendarData() {
            var args = {
                currentUserToken: localStorage.getItem("USER_TOKEN"),
                dateFrom: this.dateFrom(),
                dateTo: this.dateTo(),
                userRoleType: this.userRole,
            };
            if (this.isAdmin) {
                args = Object.assign(args, {
                    scopedOrganizationId: String(this.scopedOrganizationId),
                });
            }
            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(userCalendar),
                        variables: args,
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        if (res.data.data.userCalendar) {
                            this.calendarWeeks = res.data.data.userCalendar;
                        } else {
                            this.showNoDataMessage = true;
                        }
                    }
                });
        },
    },
};
</script>
